import { useTypedSelector } from 'src/State/RootReducer'
import { fetchSystemLogStats } from 'src/Libs/installations/api/installation.api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { FETCH_SYSTEM_LOG_STATS_FILTER } from '../consts'
import { usePortalQuery } from 'src/Libs/api'

interface ReturnType {
  hasErrorLogs: boolean
}

/**
 * Custom hook to determine if there are system logs with errors.
 */
export const useSystemLogError = (doesMeetCriteria: boolean): ReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const { activeInstallation: installationId } = useTypedSelector(state => state.storage)

  const {
    data: systemLogsWithErrorAmount,
    isLoading: systemLogsWithErrorAmountLoading,
    isError: systemLogsWithErrorAmountError,
  } = usePortalQuery<number>({
    queryKey: ['error-logs-stats', installationId],
    queryFn: async () => {
      const res = await fetchSystemLogStats(installationId ?? 0, { filter: FETCH_SYSTEM_LOG_STATS_FILTER }, authFetch)
      if (res.hasErrors) throw new Error('response has errors')
      return res.value?.count ?? 1
    },
    enabled: doesMeetCriteria && installationId !== undefined,
  })

  const hasErrorLogs = systemLogsWithErrorAmountLoading || systemLogsWithErrorAmountError || systemLogsWithErrorAmount !== 0

  return { hasErrorLogs }
}
